/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { TABLE_ROW_INDEX_ATTRIBUTE as E, TABLE_COL_INDEX_ATTRIBUTE as T, TABLE_PREVENT_SELECTION_ELEMENT as _ } from "@progress/kendo-react-data-tools";
const R = E, N = T, A = _, L = /^(?!.*\bChrome).*\bSafari/i;
export {
  N as GRID_COL_INDEX_ATTRIBUTE,
  A as GRID_PREVENT_SELECTION_ELEMENT,
  R as GRID_ROW_INDEX_ATTRIBUTE,
  L as SAFARI_REGEX
};
